function getAge(birthYear, birthMonth, birthDay) {
    var returnAge;
    var d = new Date();         //当前年月日
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1;
    var nowDay = d.getDate();
    var ageDiff = nowYear - birthYear; //年之差  
    if (ageDiff > 0) {
        if (nowMonth == birthMonth) {
            var dayDiff = nowDay - birthDay;//日之差  
            if (dayDiff < 0) {
                returnAge = ageDiff - 1;
            }
            else {
                returnAge = ageDiff;
            }
        }
        else {
            var monthDiff = nowMonth - birthMonth;//月之差  
            if (monthDiff < 0) {
                returnAge = ageDiff - 1;
            }
            else {
                returnAge = ageDiff;
            }
        }
    }
    else {
        returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天  
    }
    return returnAge;
}
module.exports = getAge;


// WEBPACK FOOTER //
// ./src/assets/js/getAge.js